import { create, useStore } from "zustand";

export type TSuggestionsStore = {
  totalSuggestions: number;
  totalPages: number;
  isSuggestionsLoading: boolean;
  selectedSuggestions: string[];
  approveProcessings: string[];
  searchQuery: string;
  isLoading: boolean;

  setApproveProcessings: (approveProcessings: string[]) => void;
  setSelectedSuggestions: (selectedSuggestions: string[]) => void;
  setTotalPages: (totalPages: number) => void;
  setTotalSuggestions: (totalSuggestions: number) => void;
  setIsSuggestionsLoading: (isSuggestionsLoading: boolean) => void;
  setSearchQuery: (searchQuery: string) => void;
  setIsLoading: (isLoading: boolean) => void;
};

export const suggestionsStore = create<TSuggestionsStore>((set) => ({
  totalSuggestions: 0,
  totalPages: 0,
  isSuggestionsLoading: false,
  selectedSuggestions: [],
  approveProcessings: [],
  searchQuery: "",
  isLoading: false,

  setApproveProcessings: (approveProcessings) => set({ approveProcessings }),
  setSelectedSuggestions: (selectedSuggestions) => set({ selectedSuggestions }),
  setTotalPages: (totalPages) => set({ totalPages }),
  setTotalSuggestions: (totalSuggestions) => set({ totalSuggestions }),
  setIsSuggestionsLoading: (isSuggestionsLoading) =>
    set({
      isSuggestionsLoading
    }),
  setSearchQuery: (searchQuery) => set({ searchQuery }),
  setIsLoading: (isLoading) => set({ isLoading })
}));

export const useSuggestionsStore = () => useStore(suggestionsStore);
